import { render } from "./internal-enrolments-overview.vue?vue&type=template&id=331888ba&ts=true"
import script from "./internal-enrolments-overview.ts?vue&type=script&lang=ts&external"
export * from "./internal-enrolments-overview.ts?vue&type=script&lang=ts&external"

import "./internal-enrolments-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__